import { render, staticRenderFns } from "./CardTextAreaRow.vue?vue&type=template&id=d46928fa&scoped=true"
import script from "./CardTextAreaRow.vue?vue&type=script&lang=js"
export * from "./CardTextAreaRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46928fa",
  null
  
)

export default component.exports